import DeleteIcon from '@mui/icons-material/Delete';
import Grid from '@mui/material/Grid2';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { useState } from 'react';
import { PaymentTypeStr } from '../../../../common/enums';
import { Order, OrderItem, Product, Station } from '../../../../common/types';
import ConfirmModal from '../../../../components/modal/ConfirmModal';
import OrderItemCards from './OrderItemCards';
import OrderPricing from './OrderPricing';

interface OrderForProps {
  orderData: Order;
  products: Product[];
  removeOrderItem: (id: number) => void;
  changeOrderItemSize: (id: number, newSizeId: number) => void;
  changeOrderStation: (stationName: string) => void;
  assignedStation: Station;
  editOrderItemVariations: (id: number) => void;
  setPaymentType: (val: PaymentTypeStr) => void;
  submitOrder: (customerName: string) => void;
  addOrderItem: (item: OrderItem) => void;
  onCancelOrder: () => void
}

export default function OrderFor({
  orderData,
  products,
  removeOrderItem,
  changeOrderItemSize,
  changeOrderStation,
  assignedStation,
  editOrderItemVariations,
  setPaymentType,
  submitOrder,
  addOrderItem,
  onCancelOrder
}: OrderForProps) {
  const theme = useTheme();
  const [customerName, setCustomerName] = useState('');
  const [confirmReset, setConfirmReset] = useState(false)

  function handleSubmitOrder() {
    submitOrder(customerName);
    setCustomerName('');
  }

  return (
    <Grid
      size={{ xs: 12, md: 5 }}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(2),
        backgroundColor: theme.palette.common.grey,
        maxHeight: '100vh',
        overflow: 'hidden',
      }}
    >
      <Stack
        flexDirection="row"
        sx={{ alignItems: 'center', marginBottom: theme.spacing(2) }}
      >
        <Typography variant="h3" fontWeight="600" sx={{ flex: 1 }}>
          Order Details:
        </Typography>
        <IconButton
          color={orderData.orderItems.length ? 'warning' : 'default'}
          disabled={!orderData.orderItems.length}
          onClick={() => setConfirmReset(true)}
        >
          <DeleteIcon />
        </IconButton>
      </Stack>
      <OrderItemCards
        orderData={orderData}
        products={products}
        addOrderItem={addOrderItem}
        removeOrderItem={removeOrderItem}
        changeOrderItemSize={changeOrderItemSize}
        changeOrderStation={changeOrderStation}
        editOrderItemVariations={editOrderItemVariations}
        submitOrder={submitOrder}
      />
      <OrderPricing
        orderData={orderData}
        changeOrderStation={changeOrderStation}
        assignedStation={assignedStation}
        setPaymentType={setPaymentType}
        submitOrder={handleSubmitOrder}
        customerName={customerName}
        setCustomerName={setCustomerName}
      />
      {
        confirmReset && (
          <ConfirmModal
            title='Cancel Order?'
            content='Are you sure you want to cancel this order?'
            onClose={() => setConfirmReset(false)}
            onConfirm={() => {
              onCancelOrder()
              setConfirmReset(false)
            }}
            confirmButtonText='Yes, Cancel'
          />
        )
      }
    </Grid>
  );
}
